import React from 'react';

export function TariffsState({className, checked}) {
  return (
    <td className={className}>
      {checked ? (
        <svg
          className="tariffs__state-checked"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="white" />
          <path
            d="M6 12L10 16L18 8"
            stroke="#0000FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          className="tariffs__state-unchecked"
          width="26"
          height="4"
          viewBox="0 0 26 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.6 3.6H25.56V0.8H0.6V3.6Z" fill="white" />
        </svg>
      )}
    </td>
  );
}
